import React, { useState } from "react";
import { Button, OverlayTrigger, Tooltip } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faComments } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const ActionsCell = ({ claim, handleStart, handleSubmitt, handleViewClick, handleChatClick, unread }) => {
  const [loading, setLoading] = useState({ start: false, submit: false });
  const { t } = useTranslation();
  const onStartClick = async (id) => {
    setLoading((prev) => ({ ...prev, start: true }));
    try {
      await handleStart(id);
    } finally {
      setLoading((prev) => ({ ...prev, start: false }));
    }
  };

  const onSubmitClick = async (id) => {
    setLoading((prev) => ({ ...prev, submit: true }));
    try {
      await handleSubmitt(id);
    } finally {
      setLoading((prev) => ({ ...prev, submit: false }));
    }
  };

  return (
    <td className="text-center">
      {claim.status === "Uploaded" ? (
        <Button className="nb" onClick={() => onStartClick(claim._id)} disabled={loading.start}>
          {loading.start ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Starting...
            </>
          ) : (
            "Start Claim"
          )}
        </Button>
      ) : (claim?.reinforcementAsk === true && claim?.enforcementAllow !== true) ? (
        //Approved
        <Button style={{ marginRight: "12px" }} className="nb" onClick={() => onSubmitClick(claim._id)} disabled={loading.submit}>
          {loading.submit ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              {t("Allowing")}
            </>
          ) : (
            `${t("AllowLawEnforcement")}`
          )}
        </Button>
        //  <Button style={{marginRight: "12px"}}  size="sm"> Allow Law Enforcement</Button>
      ) : null}
      <OverlayTrigger placement="top"
        overlay={<Tooltip>{t("chatAboutInvoice")}</Tooltip>}>
        <Button
          size="sm"
          variant="outline-secondary"
          onClick={() => handleChatClick(claim._id)}
          className="position-relative"
        >
          <FontAwesomeIcon icon={faComments} />

          {unread > 0 && (
            <span
              className="badge bg-danger text-white position-absolute"
              style={{
                top: "-6px",
                right: "-6px",
                borderRadius: "50%",
                padding: "3px 6px",
                fontSize: "10px",
              }}
            >
              {unread}
            </span>
          )}
        </Button>

      </OverlayTrigger>
      <button
        onClick={() => handleViewClick(claim._id)}
        title="View Details"
        className="btn btn-link p-0 ms-2 text-primary"
        style={{ cursor: "pointer" }}
      >
        <FontAwesomeIcon icon={faEye} size="md" />
      </button>
    </td>
  );
};

export default ActionsCell;
